const mobileUserAgentPattern = /\b(Android.+Mobile|iPhone|iPod|IEMobile|BlackBerry|BB10|Opera Mini|Mobile Safari)\b/i;

export const isMobileBrowser = (): boolean => {
  if (typeof navigator === 'undefined')
    return false;

  return mobileUserAgentPattern.test(navigator.userAgent);
};

export const isDesktopBrowser = (): boolean => !isMobileBrowser();